import { AfterViewInit, Component, EventEmitter, ElementRef, Output, ViewChild, ViewEncapsulation, Input, OnChanges, SimpleChanges } from "@angular/core";
import { appAnimations } from "../../animations";
import { ItemGaleryModel } from "../../models/item-galery.model";

@Component({
    selector: 'app-upload-file-simple',
    templateUrl: './upload-file-simple.component.html',
    styleUrls: ['./upload-file-simple.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: appAnimations
})
export class UploadFileSimpleComponent implements AfterViewInit, OnChanges {
    
    private _active = false;
    @ViewChild('boxInput') boxInput!: ElementRef;
    @ViewChild('inputFile') inputFile!: ElementRef;
    @Output() onAddFile = new EventEmitter<ItemGaleryModel>();
    @Output() onClear = new EventEmitter<void>();
    public get active(): boolean {
        return this._active;
    }
    @Input() public set active(value: boolean) {
        this._active = value;
    }
    @Input() public formats!: Array<string>;
    @Input() public disabled: boolean = false;
    @Input() public labelInput = 'Arrastra y suelta o haz click para buscar tu(s) archivo';
    @Input() public uploadFileWithError: boolean = false;
    public arrayBuffer!: Array<any>;
    public loading = false;
    public errors = false;
    public fileName = '';
    private initialLabelInput: string | null = null;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.labelInput !== 'Arrastra y suelta o haz click para buscar tu(s) archivo') {
            this.initialLabelInput = this.labelInput;
        }
    }

    ngAfterViewInit(): void {
    
        (this.inputFile.nativeElement as HTMLInputElement).addEventListener('change', (event) => {
            this.deleteDefaultEvent(event);

            if (!this.disabled) {
                const files = (event.target as HTMLInputElement).files;
                this.processFile(files!);
            }
        });
    
        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('drag', (event) => {
            this.deleteDefaultEvent(event);
        });

        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('dragstart', (event) => {
            this.deleteDefaultEvent(event);
        });

        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('dragend', (event) => {
            this.deleteDefaultEvent(event);
        });

        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('dragover', (event) => {
            this.deleteDefaultEvent(event);
        });

        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('dragenter', (event) => {
            this.deleteDefaultEvent(event);
        });

        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('dragleave', (event) => {
            this.deleteDefaultEvent(event);
        });
    
        (this.boxInput.nativeElement as HTMLDivElement).addEventListener('drop', (event) => {
            this.deleteDefaultEvent(event);
            if (!this.disabled) {
                const files = event.dataTransfer!.files;
                this.processFile(files);
            }
        });
    }

    private deleteDefaultEvent(event: DragEvent | any): void {
        event.preventDefault();
        event.stopPropagation();
    }

    private processFile(files: FileList): void {
        this.loading = true;
        this.fileName = '';

        if (files.length > 0) {
            const item: ItemGaleryModel = new ItemGaleryModel();
            this.fileName = this.labelInput = files[0].name;

            const validFormats = this.formats ?? ['png', 'jpg', 'jpeg'];
            const extendByName = files[0].name.split('.').pop();

            if (!validFormats.find((type) =>  extendByName!.toLocaleLowerCase().includes(type.toLocaleLowerCase()) || files[0].type.toLocaleLowerCase().includes(type.toLocaleLowerCase()))) {
                const lastformat = validFormats[validFormats.length - 1];
                const removeLast = validFormats.slice(0, validFormats.length - 1);

                this.arrayBuffer = [];
                this.fileName = '';
                this.errors = true;
                this.loading = false;
                this.labelInput = `Formato (${extendByName}, ${files[0].type}) no valido, formatos aceptados ${removeLast.join(', ')} o ${lastformat}.`;
                (this.inputFile.nativeElement as HTMLInputElement).value = '';
                if (this.uploadFileWithError) {
                    item.name = 'error-format';
                    this.onAddFile.emit(item);
                }

                return;
            }

            item.name = this.fileName;
            item.type = files[0].type;
            item.file = files[0];
            this.onAddFile.emit(item);

            this.errors = false;
            this.labelInput = files[0].name;
            const fileReader = new FileReader();

            fileReader.onload = (e) => {
                const arrayBuffer = fileReader.result;
                const bytes = new Uint8Array(arrayBuffer as any);
                this.arrayBuffer = [...bytes];

                this.loading = false;
            };

            fileReader.readAsArrayBuffer(files[0]);
        }
    }

    public clear(): void {
        this.arrayBuffer = [];
        this.loading = false;
        this.errors = false;
        this.fileName = '';
        this.labelInput = this.initialLabelInput === null ? 'Arrastra y suelta o haz click para buscar tu(s) archivo' : this.initialLabelInput;
        (this.inputFile.nativeElement as HTMLInputElement).value = '';

        this.onClear.emit();
    }
}